import React from 'react';

import { Box } from '@/shared/ui/box';

import { Image } from '@/shared/ui/image';

import { FooterPartners } from './styles';

export const FooterPartnersBlock = () => {
  const icons: string[] = [
    'Visa',
    'Mastercard',
    'GooglePay',
    'ApplePay',
    'Bitcoin',
    'Etherium',
    'Stripe',
    'Skrill',
  ];

  return (
    <FooterPartners>
      {icons.map((el) => {
        return (
          <Box key={el} $flex="1">
            <Image
              width={70}
              height={48}
              src={`/images/icons/payment_method_welcom/${el}.svg`}
            />
          </Box>
        );
      })}
    </FooterPartners>
  );
};
